﻿import window from 'window';
import document from 'document';

export const emailPrepopulateQuery = () => {
  
    const selectors = {
        emailField: '.form[data-component="form"] input.js-email-field'
    };
    
    const init = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const email = urlParams.get('email');

        if (email) {
            const emailFields = [...document.querySelectorAll(selectors.emailField)];

            emailFields.forEach(field => {
                field.value = email;
            });
        }
    };

    return {
        init: init
    };
};
